import { useSelector } from "react-redux";
import copyIcon from "../img/copy-icon.svg";
import { copyToClipBoard } from "../utils";
import { selectCurrentUser } from "../features/auth/authSlice";
import { useGetUserTypesQuery } from "../services/accountsApi";

export default function JobDetailsCCModal({ CCinfo, history }) {

  let { cardBrand, cardNumber, expirMonth, expirYear, cvvCode, additionalCode } = CCinfo;
  const {data: userTypes, isLoading: userTypesIsLoading} = useGetUserTypesQuery();
  const user = useSelector(selectCurrentUser);

  const canViewHistory = () => {
    if (!userTypes || !user) return false;

    const allowedTypeNames = ["Employee", "Contractor", "Hive Admin"];
    const allowedTypeIds = userTypes
      .filter(type => allowedTypeNames.includes(type.name))
      .map(type => type.id);

    return allowedTypeIds.includes(user.userTypeId);
  };

  return (
    <div className="cc-details-container" id="CreditCards-Information-Modal">

      <div className="row-CC">

        <div className="column-modal" style={{ alignItems: "flex-end" }}>
          <p id="CreditCard-Brand" style={{ fontWeight: "600", whiteSpace: "nowrap" }}>Card Brand:</p>
          <p id="CreditCard-Number" style={{ fontWeight: "600" }}>Number:</p>
          <p id="CreditCard-Expiration" style={{ fontWeight: "600" }}>Exp:</p>
          <p id="CreditCard-CVV" style={{ fontWeight: "600" }}>CVV:</p>
          {additionalCode && (
            <p id="CreditCard-AdditionalCode" style={{ fontWeight: "600" }}>Add'l Code:</p>
          )}
        </div>

        <div className="column-modal">
          <p id="CurrentCreditCard-Brand" style={{ marginLeft: "0.5em" }}>{cardBrand?.name}</p>
          <p id="CurrentCreditCard-Number" style={{ marginLeft: "0.5em" }}>
            {cardNumber ? cardNumber : "-- ERROR --"}
          </p>

          <p
            id="CurrentCreditCard-Expiration"
            style={{ marginLeft: "0.5em" }}
          >{`${expirMonth}/${expirYear}`}</p>

          <p id="CurrentCreditCard-CVV" style={{ marginLeft: "0.5em" }}>
            {cvvCode ? cvvCode : "-- ERROR --"}
          </p>

          {additionalCode && (
            <p id="CurrentCreditCard-AdditionalCode" style={{ marginLeft: "0.5em" }}>
              {additionalCode}
            </p>
          )}

        </div>

        <div className="column-modal">
          {/* ------------copy-button---------------- */}
          
            <button
              className="cc-details-button"
              id="CreditCard-Number-Copy-Button"
              onClick={async () =>
                await copyToClipBoard(cardNumber ? cardNumber : "-- ERROR --")
              }
            >
              <img src={copyIcon} alt="copy icon" height="18px" width="18px" />
            </button>
          
          {/* -----------copy-button------------------ */}
          
            <button
              className="cc-details-button"
              id="CreditCard-Expiration-Copy-Button"
              onClick={async () =>
                await copyToClipBoard(`${expirMonth}${expirYear}` ? `${expirMonth}${expirYear}` : "-- ERROR --")
              }
            >
              <img src={copyIcon} alt="copy icon" height="18px" width="18px" />
            </button>
          
          {/* -------------copy-button---------------- */}
          
            <button
              className="cc-details-button"
              id="CreditCard-CVV-Copy-Button"
              onClick={async () =>
                await copyToClipBoard(cvvCode ? cvvCode : "-- ERROR --")
              }
            >
              <img src={copyIcon} alt="copy icon" height="18px" width="18px" />
            </button>
          
          {/* -------------copy-button---------------- */}
          
            {additionalCode && (
              <button
                className="cc-details-button"
                id="CreditCard-AdditionalCode-Copy-Button"
                onClick={async () =>
                  await copyToClipBoard(additionalCode ? additionalCode : "-- ERROR --")
                }
              >
                <img src={copyIcon} alt="copy icon" height="18px" width="18px" />
              </button>
            )}
            
        </div>
      </div>

      {canViewHistory() && (
        <>
          <div className="row-modal-2" >
            <p
              style={{
                fontSize: "var(--caption",
                lineHeight: "normal",
                color: "var(--grey-inactive",
              }}
            >
              {" "}
              Card details viewed {history.date}{" "}
            </p>
          </div>

          <div style={{ height: "fit-content" }}>
            <p
              id="CurrentCreditCard-LastViewedBy-information" 
              style={{
                fontSize: "var(--caption",
                lineHeight: "normal",
                color: "var(--grey-inactive",
              }}
            >
              {" "}
              by {history.userName}
            </p>
          </div>
        </>
      )}
    </div>
  );
}
